module.exports = __webpack_public_path__ + "static/logo_full-68518b08d9fd7e9ee9ab6b3779e8c778.svg";